import React, { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import Pool from "../Userpool";
import usuarioService from "../services/usuario.service";

const AccountContext = createContext();

const Account = (props) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState(false);
  const [usuario, setUsuario] = useState(null);
  const getSession = async () => {
    return await new Promise((resolve, reject) => {
      const user = Pool.getCurrentUser();
      if (user) {
        user.getSession(async (err, session) => {
          if (err) {
            reject();
          } else {
            setStatus(true);
            let u = await usuarioService.getBySSID(session.idToken.payload.sub);
            setUsuario(u.data[0]);
            resolve(session);
          }
        });
      } else {
        reject();
      }
    });
  };

  const authenticate = async (Username, Password) => {
    return await new Promise((resolve, reject) => {
      const user = new CognitoUser({ Username, Pool });

      const authDetails = new AuthenticationDetails({ Username, Password });

      user.authenticateUser(authDetails, {
        onSuccess: async (data) => {
          let u = null;
          try {
            u = await usuarioService.getBySSID(data.idToken.payload.sub);
          } catch (ex) {
            setStatus(false);
            alert("Error de conexión");
            return;
          }
          console.log("onSuccess: ", data);
          resolve(data);
          setStatus(true);
          setUsuario(u.data[0]);
          navigate("/inicio");
        },
        onFailure: (err) => {
          console.error("onFailure: ", err);
          reject(err);
        },
        newPasswordRequired: (data) => {
          console.log("newPasswordRequired: ", data);
          resolve(data);
        },
      });
    });
  };

  const logout = () => {
    const user = Pool.getCurrentUser();
    if (user) {
      user.signOut();
      setStatus(false);
      return;
      //navigate("/");
    }
  };
  return (
    <AccountContext.Provider value={{ authenticate, getSession, logout, status, usuario }}>
      {props.children}
    </AccountContext.Provider>
  );
};
export { Account, AccountContext };